import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ERROR_MESSAGES } from 'src/app/constants/error-messages';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent {
  message: string = ERROR_MESSAGES['GENERAL_ACCESS_DENIED'];

  constructor(private route: ActivatedRoute) {
    const errorCode = this.route.snapshot.queryParamMap.get('errorCode');
    this.setMessageFromCode(errorCode);
  }

  private setMessageFromCode(code: string | null) {
    if (code && ERROR_MESSAGES[code]) {
      this.message = ERROR_MESSAGES[code];
    } else {
      this.message = ERROR_MESSAGES['GENERAL_ACCESS_DENIED'];
    }
  }
}